import React, { useMemo } from 'react'
import { Tooltip } from '../../common'
import { INTEGRAL_LP_FARMING_URL } from '../../constants'
import { formatPoolMinimumTVL } from '../../utils'

interface Props {
  poolBalanceThresholds?: number[]
  poolMinimumTVL?: number
}

export function LpRewardsTooltip({ poolBalanceThresholds, poolMinimumTVL }: Props) {
  const text = useMemo(() => {
    let msg = `LPs earn rewards every block`
    let condition = false
    if (poolBalanceThresholds && poolBalanceThresholds[0]) {
      msg += ` ${condition ? 'and' : 'if'} the "POOL RATIO" is ≥ ${
        poolBalanceThresholds ? poolBalanceThresholds[0] : '-'
      }%`
      condition = true
    }
    if (poolBalanceThresholds && poolBalanceThresholds[1] && poolBalanceThresholds[1] !== 100) {
      msg += ` ${condition ? 'and' : 'if'} the "POOL RATIO" is ≤ ${
        poolBalanceThresholds ? poolBalanceThresholds[1] : '-'
      }%`
      condition = true
    }
    if (poolMinimumTVL) {
      msg += ` ${condition ? 'and' : 'if'} "TVL" is ≥ ${formatPoolMinimumTVL(poolMinimumTVL)}`
      condition = true
    }
    msg += '.'
    return msg
  }, [poolBalanceThresholds, poolMinimumTVL])

  return (
    <Tooltip right>
      <p>{text}</p>
      <p>
        Learn more{' '}
        <a href={INTEGRAL_LP_FARMING_URL} target="_blank">
          here
        </a>
        .
      </p>
    </Tooltip>
  )
}
